var React = require('react');

function Search (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"12","cy":"12","r":"7","stroke":"currentColor","strokeWidth":"2","key":0}),React.createElement("line",{"x1":"16.2071","y1":"16.2929","x2":"21.1569","y2":"21.2426","stroke":"currentColor","strokeWidth":"2","key":1})]);
}

Search.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Search;

Search.default = Search;
